<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Rank Calculation </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-radio-group v-model="rankType" row>
                    <v-radio label="Course Rank Calculation" value="course"></v-radio>
                    <v-radio label="Overall Rank Calculation" value="overall"></v-radio>
                </v-radio-group>
            </v-row>
            <span v-if="rankType == 'course'" dense justify="center">
                <hr />
                <v-row dense justify="center">
                    <v-radio-group v-model="rankTypeCourse" row>
                        <v-radio
                            label="Show Exam Wise Rank Calculation"
                            value="exam"
                            @change="clearAll"
                        ></v-radio>
                        <v-radio
                            label="Show Course Overall Rank Calculation"
                            value="crs_overall"
                            @change="clearAll"
                        ></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row dense justify="center" v-if="rankTypeCourse!=null">
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Select Academic Year"
                            outlined
                            @change="getStd()"
                            persistent-hint
                            hint="Please select academic year"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            dense
                            required
                            outlined
                            rounded
                            color="#0F2027"
                            v-model="sem"
                            :items="semester_list"
                            item-text="display_name"
                            item-value="id"
                            label="Semester"
                            persistent-hint
                            hint="Please select semester"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_std_data"
                            return-object
                            :items="std_div_list"
                            item-text="std"
                            label="Standard"
                            outlined
                            @change="
            getDiv();
            getStandardCourse();
        "
                            persistent-hint
                            hint="Please select standard"
                            @click="putnull"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="div"
                            item-value="div_off_id"
                            :items="div_list"
                            item-text="div_name"
                            label="Division"
                            outlined
                            persistent-hint
                            hint="Please select division"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="crs_id"
                            item-value="c_id"
                            :items="crs_list"
                            item-text="course"
                            label="Course"
                            outlined
                            @change="getassessmentschemedetails()"
                            persistent-hint
                            hint="Please select course"
                            @click="putnull2"
                        />
                    </v-col>
                    <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != '' && rankTypeCourse == 'exam'">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="assessment_detail"
                            item-value="id"
                            :items="assessment_detail_list"
                            item-text="assessmenttype"
                            label="Assessment Scheme Details"
                            outlined
                            persistent-hint
                            hint="Please select assessment scheme details"
                            @click="putnull3"
                        />
                    </v-col>
                    <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="status"
                            :items="status_list"
                            item-text="name"
                            item-value="id"
                            label="Status"
                            outlined
                            persistent-hint
                            hint="Select Status"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && crs_id">
                        <v-btn class="mt-6 button" @click="getCrsExamRankDetails()" :loading="fetch_loader"
                            >Fetch</v-btn
                        >
                    </v-col>
                </v-row>
                 <v-row justify="start" class="mb-2 ml-2" v-if="learner_course_list!=null">
                         <v-btn class="ma-2 no-display" tile outlined color="success" @click="exportCRSExcel()">
                                <v-icon left>mdi-file-excel</v-icon> Excel
                        </v-btn>
                </v-row>
                <div id="my-table-id" v-if="learner_course_list!=null">
                    <div class="table-container">
                        <v-simple-table fixed-header dense class="elevation-1">
                            <thead>
                                <tr>
                                    <th class="">
                                        <center>Sr. No.</center>
                                    </th>
                                    <th class="">
                                        <center>Roll No.</center>
                                    </th>
                                    <th class="">
                                        <center>Division</center>
                                    </th>
                                    <th class="">
                                        <center>Registration No.</center>
                                    </th>
                                    <th class="">
                                        <center>Name</center>
                                    </th>
                                    <th
                                        class=""
                                        v-for="header in ass_detail_list"
                                        :key="header"
                                        v-if="rankTypeCourse == 'exam'"
                                    >
                                        <center>{{ header }}</center>
                                    </th>
                                    <td v-if="rankTypeCourse == 'crs_overall'">Total Marks</td>
                                    <td v-if="rankTypeCourse == 'crs_overall'">Rank</td>
                                    <td v-if="rankTypeCourse == 'crs_overall'">Already Saved Rank</td>
                                    <th class="">
                                        <center>Save / Update</center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in learner_course_list" :key="s.cid">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.registration_number }}</td>
                                    <td>{{ s.name }}</td>
                                    <td
                                        v-for="(header, index) in s.comp_marks"
                                        :key="index"
                                        v-if="rankTypeCourse == 'exam'"
                                    >
                                        <center>{{ header }}</center>
                                    </td>
                                    <td v-if="rankTypeCourse == 'crs_overall'">{{ s.total_marks }}</td>
                                    <td v-if="rankTypeCourse == 'crs_overall'">{{ s.rank }}</td>
                                    <td v-if="rankTypeCourse == 'crs_overall'">{{ s.already_rank }}</td>
                                    <td>
                                        <v-btn
                                            class="mt-6 button"
                                            small
                                            :loading="save_loader"
                                            @click="saveSingleStudent(s)"
                                            >Save / Update</v-btn
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <v-row align="center" justify="center">
                        <v-btn class="mt-6 button" :loading="save_loader" @click="saveAllRanks()">Save / Update</v-btn>
                    </v-row>
                </div>
            </span>
            <span v-if="rankType == 'overall'" > 
                <v-row dense justify="center">
                <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_ay_data"
                            return-object
                            :items="ay_std_div_list"
                            item-text="ay"
                            label="Select Academic Year"
                            outlined
                            @change="getStd()"
                            persistent-hint
                            hint="Please select academic year"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            dense
                            required
                            outlined
                            rounded
                            color="#0F2027"
                            v-model="sem"
                            :items="semester_list"
                            item-text="display_name"
                            item-value="id"
                            label="Semester"
                            persistent-hint
                            hint="Please select semester"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="entrytype"
                        item-value="id"
                        :items="entrytype_list"
                        item-text="name"
                        label="Select Course Tpe"
                        outlined
                        persistent-hint
                        hint="Please select Course Tpe"
                    />
                </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="sel_std_data"
                            return-object
                            :items="std_div_list"
                            item-text="std"
                            label="Standard"
                            outlined
                            @change="
            getDiv();
        "
                            persistent-hint
                            hint="Please select standard"
                            @click="putnull"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="div"
                            item-value="div_off_id"
                            :items="div_list"
                            item-text="div_name"
                            label="Division"
                            outlined
                            persistent-hint
                            hint="Please select division"
                        />
                    </v-col>
                      <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="status"
                            :items="status_list"
                            item-text="name"
                            item-value="id"
                            label="Status"
                            outlined
                            persistent-hint
                            hint="Select Status"
                        />
                    </v-col>
                     <v-col sm="2">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete
                            color="#0F2027"
                            dense
                            rounded
                            required
                            v-model="type"
                            :items="type_list"
                            item-text="name"
                            item-value="id"
                            label="Calculation Type"
                            outlined
                            persistent-hint
                            hint="Select Calculation Type"
                        />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && status && type">
                        <v-btn class="mt-6 button" @click="getOverallRankDetails()" :loading="fetch_loader"
                            >Fetch</v-btn
                        >
                    </v-col>
                    </v-row>
                    <v-row justify="start" class="mb-2 ml-2" v-if="learner_rank_list!=null">
                         <v-btn class="ma-2 no-display" tile outlined color="success" @click="exportCRSExcel()">
                                <v-icon left>mdi-file-excel</v-icon> Excel
                        </v-btn>
                 </v-row>
                     <div id="my-table-id" v-if="learner_rank_list!=null">
                    <div class="table-container">
                        <v-simple-table fixed-header dense class="elevation-1">
                            <thead>
                                <tr>
                                    <th class="">
                                        <center>Sr. No.</center>
                                    </th>
                                    <th class="">
                                        <center>Roll No.</center>
                                    </th>
                                    <th class="">
                                        <center>Division</center>
                                    </th>
                                    <th class="">
                                        <center>Registration No.</center>
                                    </th>
                                    <th class="">
                                        <center>Name</center>
                                    </th>
                                    <th>Out Off Marks</th>
                                    <th>Total Marks</th>
                                    <th>Percentage</th>
                                    <th>Rank</th>
                                    <th>Already Saved Rank</th>
                                    <!-- <th>Remark</th> -->
                                    <th class="">
                                        <center>Save / Update</center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in learner_rank_list" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.rollno }}</td>
                                    <td>{{ s.division }}</td>
                                    <td>{{ s.registration_number }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.out_off_marks }}</td>
                                    <td>{{ s.total_marks }}</td>
                                    <td>{{ s.percentage }}</td>
                                    <td>{{ s.rank }}</td>
                                    <td>{{ s.result_rank }}</td>
                                    <!-- <td> <v-textarea label="Enter Remark" v-model="s.result_remark" rows="3" outlined /></td> -->
                                    <td>
                                        <v-btn
                                            class="mt-6 button"
                                            small
                                            :loading="fetch_loader"
                                            @click="saveSingleStudent(s)"
                                            >Save / Update</v-btn
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                    <v-row align="center" justify="center">
                        <v-btn class="mt-6 button" :loading="fetch_loader" @click="saveAllRanks()">Save / Update</v-btn>
                    </v-row>
                </div>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import * as XLSX from "xlsx";
    export default {
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                rankType: null,
                div: null,
                semester_list: null,
                sem: null,
                semester: null,
                fetch_loader: false,
                save_loader:false,
                assessment_detail_list: [],
                assessment_detail: null,
                standard: null,
                division: null,
                course: null,
                ass_Scheme: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: null,
                inst_name: null,
                ass_converted_total: null,
                show: false,
                org_basic_data: [],
                default_value: null,
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
                type_list: [
                    { name: "As per School Result", id: "1" },
                    { name: "As per Parent Result", id: "2" },
                ],
                type: null,
                orgid: null,
                tenant: null,
                rankTypeCourse: null,
                entrytype_list: [],
                entrytype: null,
            };
        },

        methods: {
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            getassessmentschemedetails() {
                if (this.rankTypeCourse != "exam") return;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getassessmentschemewithoutrubrics", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                            this.assessment_detail_list.unshift({ id: "null", assessmenttype: "All" });
                            this.assessment_detail = null;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStandardCourse() {
                // let div = this.div.div_id;
                // if (this.div.div_id) {
                //     div = this.div.div_id;
                // } else {
                //     div = this.div;
                // }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                };
                axios
                    .post("/Examination/getStandardCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.courses_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered for this standard..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        //     this.sel_ay_data = res.data.curr_ay;
                        this.semester_list = res.data.sem_list;
                        this.entrytype_list = ["All"];
                        this.entrytype_list = res.data.entrytype_list;
                        this.entrytype_list.unshift("All");
                        this.entrytype = this.entrytype_list[0];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },

            async getOverallRankDetails(){
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                    status: this.status,
                    entrytype: this.entrytype,
                    calculation_type:this.type
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/Examination/getOverallRankDetails", data);
                    if (res.data.flag == "YES") {
                        this.learner_rank_list = res.data.learner_rank_list
                         // 👉 Step 1: Convert percentage to number (keep 0 also)
                        let sortedList = this.learner_rank_list.map(item => {
                            let perc = parseFloat(item.percentage);
                            return {
                                ...item,
                                perc: isNaN(perc) ? 0 : perc // ✅ treat invalid as 0
                            };
                        });

                        // 👉 Step 2: Sort DESC
                        sortedList.sort((a, b) => b.perc - a.perc);

                        // 👉 Step 3: DENSE RANK (no skipping)
                        let rank = 1;
                        sortedList.forEach((item, index) => {
                            if (index > 0 && item.perc < sortedList[index - 1].perc) {
                                rank++;
                            }
                            item.rank = rank;
                        });

                    // 👉 Step 4: Map back
                    this.learner_rank_list = this.learner_rank_list
                        .map(student => {
                            const found = sortedList.find(
                                s => s.registration_number === student.registration_number
                            );
                            return {
                                ...student,
                                rank: found.rank
                            };
                        })
                        .sort((a, b) => a.rank - b.rank); // sort by rank

                                this.fetch_loader = false;
                                this.show = true;
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                                this.fetch_loader = false;
                            } else {
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                                this.fetch_loader = false;
                            }
                            this.standard = res.data.standard;
                            this.semester = res.data.semester;
                        } catch (err) {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.fetch_loader = false;
                        } finally {
                            this.fetch_loader = false;
                        }
            },

            async getCrsExamRankDetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.sem,
                    div: this.div,
                    ass_id: this.assessment_detail,
                    ass_id_list: this.assessment_detail_list,
                    status: this.status,
                    rankTypeCourse: this.rankTypeCourse,
                };
                this.fetch_loader = true;
                try {
                    const res = await axios.post("/Examination/getCrsExamRankDetails", data);
                    if (res.data.flag == "YES") {
                        this.fetch_loader = false;
                        this.standard = res.data.standard;
                        this.division = res.data.div;
                        this.course = res.data.course;
                        this.semester = res.data.semester;
                        this.ass_Scheme = res.data.ass_Scheme;
                        this.academicyear = res.data.ay;
                        this.ass_detail_list = res.data.ass_detail_list;
                        this.learner_course_list = res.data.learner_course_list;
                        this.inst_name = res.data.inst_name;
                        this.ass_converted_total = res.data.ass_converted_total;
                        this.org_basic_data = res.data.org_basic_data;

                        // 🔥 ✅ INLINE RANK LOGIC START
                        if (this.learner_course_list != null && this.rankTypeCourse == "exam") {
                            const totalColumns = this.learner_course_list[0].comp_marks.length;

                            for (let index = 0; index < totalColumns; index += 3) {
                                let marksArray = this.learner_course_list
                                    .map((item) => {
                                        let val = item.comp_marks[index];
                                        let marks = val === "NA" || val === "--" ? null : Number(val);

                                        return {
                                            cid: item.cid,
                                            marks: isNaN(marks) ? null : marks,
                                        };
                                    })
                                    .filter((item) => item.marks !== null);

                                // 👉 Sort descending
                                marksArray.sort((a, b) => b.marks - a.marks);

                                let rankMap = {};
                                let rank = 1;

                                // ✅ CONTINUOUS RANK (1,1,2,3 NO SKIP)
                                marksArray.forEach((item, i) => {
                                    if (i > 0 && item.marks < marksArray[i - 1].marks) {
                                        rank++; // ✅ increase by 1 only (not i+1)
                                    }
                                    rankMap[item.cid] = rank;
                                });

                                // 👉 Assign back
                                this.learner_course_list.forEach((student) => {
                                    if (rankMap[student.cid]) {
                                        student.comp_marks[index + 1] = rankMap[student.cid];
                                    } else {
                                        student.comp_marks[index + 1] = "--";
                                    }
                                });
                            }

                            // 👉 Sort by first exam rank
                            this.learner_course_list.sort((a, b) => {
                                let r1 = a.comp_marks[1] === "--" ? Infinity : a.comp_marks[1];
                                let r2 = b.comp_marks[1] === "--" ? Infinity : b.comp_marks[1];
                                return r1 - r2;
                            });
                        } else {
                            // 👉 Step 1: Sort by total_marks (desc)
                            const sortedList = [...this.learner_course_list].sort(
                                (a, b) => b.total_marks - a.total_marks
                            );

                            // 👉 Step 2: Assign rank (DENSE RANKING)
                            let rank = 1;

                            sortedList.forEach((item, index) => {
                                if (index > 0 && item.total_marks < sortedList[index - 1].total_marks) {
                                    rank++; // ✅ only increment by 1 (NO SKIP)
                                }
                                item.rank = rank;
                            });

                            // 👉 Step 3: Map rank back + sort by rank
                            this.learner_course_list = this.learner_course_list
                                .map((student) => {
                                    const found = sortedList.find((s) => s.cid === student.cid);
                                    return {
                                        ...student,
                                        rank: found.rank,
                                    };
                                })
                                .sort((a, b) => a.rank - b.rank);
                        }
                        // 🔥 ✅ INLINE RANK LOGIC END

                        this.fetch_loader = false;
                        this.show = true;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.fetch_loader = false;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.fetch_loader = false;
                    }
                } catch (err) {
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                    this.fetch_loader = false;
                } finally {
                    this.fetch_loader = false;
                }
            },

            saveSingleStudent(student) {
                let marks_data = [];
                let data = [];
                this.save_loader = true;
                console.log(this.rankType);
                

                if(this.rankType === "overall"){
                    data = {
                        learnerMarkSheet: student.learnerMarkSheet,
                        total_marks: student.total_marks,
                        out_off_marks: student.out_off_marks,
                        rank: student.rank,
                        sem: student.sem,
                        percentage: student.percentage,
                        // result_remark: student.result_remark,
                        rankType : this.rankType,
                        standard: this.standard,
                        ay: this.sel_ay_data.ay_id,
                        learner_id: student.learner_id,
                        div_off: student.div_off
                    }
                }else{
                    if(this.rankTypeCourse === "exam"){
                        for (let i = 0; i < student.comp_marks.length; i += 3) {
                            marks_data.push({
                                ass_id: student.comp_marks_id[i / 3],
                                rank: student.comp_marks[i + 1],
                            });
                        }

                        data = {
                            cid: student.cid,
                            marks_data: marks_data,
                            rankTypeCourse:this.rankTypeCourse,
                            rankType:this.rankType,
                            div_off: student.division_off,
                            sem: student.sem,
                            co_off: student.courseOffering,
                            ay: this.sel_ay_data.ay_id,
                        };

                    }else if(this.rankTypeCourse === "crs_overall"){
                        data = {
                            cid: student.cid,
                            learner_id: student.learner_id,
                            total_marks: student.total_marks,
                            rank: student.rank,
                            rankTypeCourse:this.rankTypeCourse,
                            rankType:this.rankType,
                            learner_course_marks : student.learnerCourseMarks,
                            sem : student.sem,
                            div: student.division,
                            ay: this.sel_ay_data.ay_id,
                            div_off: student.division_off,
                            standard: student.standard,
                            co_off: student.courseOffering
                        };
                    }
                }
                
                axios
                    .post("/Examination/saveStudentRank", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.getCrsExamRankDetails();
                            this.getOverallRankDetails();
                            this.showSnackbar("success", "Rank saved successfully...");
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "Something went wrong");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },

            saveAllRanks() {
                this.save_loader = true;
                let studentsPayload = [];

                if (this.rankType === "overall") {

                    studentsPayload = this.learner_rank_list.map((student) => {
                        return {
                            learnerMarkSheet: student.learnerMarkSheet,
                            learner_id: student.learner_id,
                            total_marks: student.total_marks,
                            out_off_marks: student.out_off_marks,
                            percentage: student.percentage,
                            rank: student.rank,
                            // result_remark: student.result_remark,
                            sem: this.semester,
                            div_off: student.div_off
                        };
                    });

                } else {
                    studentsPayload = this.learner_course_list.map((student) => {

                        if(this.rankTypeCourse === "crs_overall"){
                            return {
                                cid: student.cid,
                                learner_id: student.learner_id,
                                total_marks: student.total_marks,
                                rank: student.rank,
                                learner_course_marks: student.learnerCourseMarks,
                                div_off: student.division_off
                            };
                        } else {
                            let marks_data = [];
                            for (let i = 0; i < student.comp_marks.length; i += 3) {
                                marks_data.push({
                                    ass_id: student.comp_marks_id[i / 3],
                                    marks: student.comp_marks[i],
                                    rank: student.comp_marks[i + 1],
                                });
                            }
                            return {
                                cid: student.cid,
                                marks_data: marks_data
                            };
                        }
                    });
                }
                const payload = {
                    students: studentsPayload,
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_id: this.crs_id,
                    sem: this.semester,
                    div: this.div,
                    rankTypeCourse:this.rankTypeCourse,
                    rankType:this.rankType
                };

                axios
                    .post("/Examination/saveAllStudentsRanks", payload)
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.getCrsExamRankDetails();
                            this.getOverallRankDetails();
                            this.showSnackbar("green", "Ranks saved successfully!");
                        } else {
                            this.showSnackbar("red", res.data.msg);
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("red", "Something went wrong");
                    })
                    .finally(() => {
                        this.save_loader = false;
                    });
            },

            clearAll(){
                this.learner_course_list = null;
                this.sel_ay_data = null;
                this.sem = null;
                this.sel_std_data = null;
                this.div = null,
                this.crs_id = null;
                this.assessment_detail = null;
                this.status = null;
            },

            exportCRSExcel() {
                if (
                    (this.rankType === "course" && !this.learner_course_list) ||
                    (this.rankType === "overall" && !this.learner_rank_list)
                ) {
                    this.showSnackbar("red", "No data available to export");
                    return;
                }

                this.save_loader = true;

                        try {
                            let excelData = [];

                            if (this.rankType === "course" && this.rankTypeCourse === "exam") {

                        excelData = this.learner_course_list.map((student, index) => {

                            let row = {
                                "Sr No": index + 1,
                                "Roll No": student.rollno,
                                "Division": student.division,
                                "Registration No": student.registration_number,
                                "Name": student.name
                            };

                            let subjects = [];
                            for (let i = 0; i < this.ass_detail_list.length; i += 3) {
                                subjects.push(this.ass_detail_list[i]);
                            }

                            subjects.forEach((subject, i) => {
                                let baseIndex = i * 3;

                                let marks = student.comp_marks[baseIndex] ? student.comp_marks[baseIndex] : "--";
                                let rank  = student.comp_marks[baseIndex + 1] ? student.comp_marks[baseIndex + 1] : "--";

                                row[`${subject} Marks`] = marks;
                                row[`${subject} Rank`] = rank;
                            });

                            return row;
                        });
                    }

                    else if (this.rankType === "course" && this.rankTypeCourse === "crs_overall") {

                        excelData = this.learner_course_list.map((student, index) => ({
                            "Sr No": index + 1,
                            "Roll No": student.rollno,
                            "Division": student.division,
                            "Registration No": student.registration_number,
                            "Name": student.name,
                            "Total Marks": student.total_marks ? student.total_marks :"--",
                            "Rank": student.rank ? student.rank : "--",
                        }));
                    }

                    else if (this.rankType === "overall") {

                        excelData = this.learner_rank_list.map((student, index) => ({
                            "Sr No": index + 1,
                            "Roll No": student.rollno,
                            "Division": student.division,
                            "Registration No": student.registration_number,
                            "Name": student.name,
                            "Out Of Marks": student.out_off_marks ? student.out_off_marks : "--",
                            "Total Marks": student.total_marks ? student.total_marks : "--",
                            "Percentage": student.percentage ? student.percentage : "--",
                            "Rank": student.rank ? student.rank : "--",
                        }));
                    }

                    if (excelData.length === 0) {
                        this.showSnackbar("red", "No valid data to export");
                        return;
                    }

                    const worksheet = XLSX.utils.json_to_sheet(excelData);
                    const colWidths = Object.keys(excelData[0]).map(key => ({
                        wch: Math.max(key.length + 5, 15)
                    }));
                    worksheet["!cols"] = colWidths;
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Rank Report");
                    let fileName = `Rank_Report_${this.rankType}`;

                    if (this.rankType === "course") {
                        fileName += `_${this.rankTypeCourse}`;
                    }

                    fileName += `.xlsx`;
                    XLSX.writeFile(workbook, fileName);
                    this.showSnackbar("green", "Excel exported successfully");

                } catch (error) {
                    console.error(error);
                    this.showSnackbar("red", "Export failed");
                } finally {
                    this.save_loader = false;
                }
            }
        },

        mounted() {
            this.onload();
            this.orgid = localStorage.getItem("EPS-org-id");
            this.awspath = localStorage.getItem("awspath");
            this.tenant = localStorage.getItem("EPS-tenant");
        },
    };
</script>
<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }

    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }

    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }

        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }

    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }

    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }

    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }

    .t-row {
        padding: 1rem i !important;
    }

    .mytable /deep/ thead th {
        background: #0f2027 !important;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }

    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }

    .delete-avatar:hover {
        background-color: transparent;
    }

    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }

    .delete-v-icon:hover {
        color: white;
    }

    .v-dialogss {
        bottom: 880;
        right: 0;
    }

    .table-container {
        max-height: 800px;
        overflow-y: auto;
        overflow-x: auto;
        border: 1px solid #ccc;
        position: relative;
    }

    .table-container ::v-deep .v-data-table__wrapper {
        overflow: visible !important;
    }

    .table-container table thead th,
    .table-container table thead td {
        position: sticky;
        top: 0;
        z-index: 3;
        background-color: #f5f5f5;
        box-shadow: inset 0 -1px 0 #ccc;
    }

    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        /*  img {
            width: 100% !important;
        }*/
        body,
        tr,
        th,
        td {
            font-size: 14pt !important;
            font-weight: bold !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            /*size: 15.5in 15.5in;*/
            size: 16in 20in;
        }

        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }

        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important;
        }
    }

    .trust-logo {
        width: 50%;
        padding-right: 10px;
    }

    .schl-logo {
        width: 50%;
        padding-left: 10px;
    }
    .table-container {
        max-height: 800px;
        overflow-y: auto;
        overflow-x: auto;
        border: 1px solid #ccc;
    }
</style>
